/**
 * UI gates for commercial price agreements.
 *
 * Canonical backend contract:
 * - SYSTEM_COMMERCIAL_AGREEMENTS_ENABLED → pricing.commercial_agreements_enabled
 * - Exposed on GET …/billing-overview as commercial_price_agreements_enabled
 *
 * Fail closed: missing / false / unknown hide agreement controls.
 * 503 (feature disabled) and 404 (FE-before-BE) are treated as disabled.
 */

export function commercialAgreementsEnabledFromOverview(overview) {
  return overview?.commercial_price_agreements_enabled === true;
}

export function isCommercialAgreementsUnavailableError(error) {
  const status = error?.response?.status ?? error?.status ?? null;
  return status === 503 || status === 404;
}

/**
 * @param {{
 *   hasPermission?: boolean,
 *   overviewEnabled?: boolean,
 *   unavailable?: boolean,
 * }} flags
 */
export function commercialAgreementsControls({
  hasPermission = false,
  overviewEnabled = false,
  unavailable = false,
} = {}) {
  const showPanel = hasPermission === true
    && overviewEnabled === true
    && unavailable !== true;

  return {
    showPanel,
    allowQuoteHint: showPanel,
  };
}
